document.addEventListener("turbolinks:load", () => {
  document.querySelectorAll("a[id^='toggle-resource-info-']").forEach( button => {
    var resourceId = button.id.replace("toggle-resource-info-", "");
    var toggleIconClassList = button.querySelector('i').classList;
    var additionalInfo = document.getElementById("resource-info-" + resourceId);

    toggleInfo(button, toggleIconClassList, additionalInfo);
  });
});

function toggleInfo(button, icon, additionalInfo) {
  button.addEventListener("click", e => {
    e.preventDefault();

    if (additionalInfo.style.display == "table-row") {
      additionalInfo.style.display = "none";
      icon.replace("fe-arrow-up", "fe-arrow-down");
    } else {
      additionalInfo.style.display = "table-row";
      icon.replace("fe-arrow-down", "fe-arrow-up");
    }
  });
}
